import React, { useState } from "react";
import axios from "axios";
import { Button, Form, Modal } from "react-bootstrap";
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";
import { login } from "../../store/auth/auth";
import * as Yup from "yup";
import { AXIOS, api_key } from "../../config";
import Loader from "../loader/loader";
import { BsXCircle, BsXSquareFill } from "react-icons/bs";

import { toast } from "react-toastify";
import { MdEmail } from "react-icons/md";

export default function Update2fa({ show, handleClose, data }) {
  const dispatch = useDispatch();
  let userid = sessionStorage.getItem("userid");
  const [isLoading, setLoading] = useState<Boolean>(false);
  const [twofa, setTwofa] = useState("");

  const pinSchema = Yup.object().shape({
    mailPin: Yup.string().required("Email pin is required"),
    twofa: Yup.string().required("Two factor pin is required"),
  });

  const formik = useFormik({
    initialValues: {
      mailPin: "",
      twofa: "",
    },
    validationSchema: pinSchema,
    onSubmit: async (values, action) => {
      setLoading(true);
      await AXIOS.post(`/getUserInfo`, {
        api_key: api_key,
        user_id: userid,
      })
        .then((response) => {
          if (response.data.status == "success") {
            setTwofa(response.data.twofa);
          }
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
          toast.error("Request Failed", { icon: <BsXSquareFill /> });
          return;
        });

      let newValues1 = {
        user_id: userid,
        mailPin: values.mailPin,
        twofapin: values.twofa,
        api_key: api_key,
        twofa: twofa,
      };
      await AXIOS.post(`/update2fa`, newValues1)
        .then((response) => {
          if (response.data.status == "success") {
            toast.success("Request Successful");
            setLoading(false);
          } else {
            console.log("Request failed");
            toast.error(response.data.showableMessage, {
              icon: <BsXSquareFill />,
            });
          }
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
          toast.error("Request Failed", { icon: <BsXSquareFill /> });
        });
      handleClose();
    },
  });
  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton className="sign_modale">
          <BsXCircle
            className="btn-cross"
            style={{ color: "var(--text-clr)" }}
            onClick={handleClose}
          />
        </Modal.Header>
        <Modal.Body className="sign_modale">
          <Form onSubmit={formik.handleSubmit}>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <div className="col-12 d-flex justify-content-center align-items-center">
                <h1 className=" text-white">Update Two Factor</h1>
              </div>
              <Form.Label style={{ color: "var(--text-clr)" }}>
                Email address
              </Form.Label>
              <Form.Control
                type="email"
                placeholder="name@example.com"
                value={data}
                autoFocus
                disabled
              />
            </Form.Group>
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label style={{ color: "var(--text-clr)" }}>
                Email Pin
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="00000"
                autoFocus
                name="mailPin"
                value={formik.values.mailPin}
                onChange={formik.handleChange}
              />
              {formik.errors.mailPin && (
                <div id="mailPin" style={{ color: "var(--text-clr)" }}>
                  {formik.errors.mailPin}
                </div>
              )}
            </Form.Group>
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label style={{ color: "var(--text-clr)" }}>2 Fa</Form.Label>
              <Form.Control
                type="text"
                placeholder="00000"
                autoFocus
                name="twofa"
                value={formik.values.twofa}
                onChange={formik.handleChange}
              />
              {formik.errors.twofa && (
                <div id="twofa" style={{ color: "var(--text-clr)" }}>
                  {formik.errors.twofa}
                </div>
              )}
            </Form.Group>

            {isLoading == false ? (
              <Button type="submit">Submit</Button>
            ) : (
              <Loader />
            )}
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}
